import { SHADOW_COLOR_ONE, WHITE, MERCHANT_LIGHT11, PRIMARY_PAYMENT_LIGHT } from 'src/global/theme/colors';
import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    headerContainer: {
      padding: "0 40px",
      margin: 0,
      border: 0,
      height: 146,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative'
    },
    hasBackground: {
      backgroundColor: WHITE,
      boxShadow: SHADOW_COLOR_ONE
    },
    titleAndButtonContainer: {
      justifyContent: 'space-between',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row'
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    secondTitle: {
      paddingLeft: "8px"
    },
    subTitle: {
      paddingTop: "8px"
    },
    goBackContainer: {
      marginBlock: "40px",
      cursor: 'pointer'
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    icon: { height: 20, width: 20, marginRight: "24px" },
    iconTitle: {
      width: 42,
      marginLeft: "16px",
      verticalAlign: 'text-bottom',
      height: 42
    },
    extraSpaceBottom: {
      marginBottom: "32px"
    },
    avatar: {
      backgroundColor: MERCHANT_LIGHT11,
      color: PRIMARY_PAYMENT_LIGHT,
      width: 60,
      height: 60,
      fontWeight: 500,
      fontSize: 18,
      lineHeight: '24px',
      marginRight: 16
    },
    tabMenu: {
      marginLeft: '-12px'
    },
    downloadButton: {
      display: "flex",
      justifyContent: "end"
    }
  };
});
